import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const {
	colors,
	common: { borderRadius },
	spacing,
	typography,
	queries,
} = THEME;

export const styleSheet = StyleSheet.create({
	card: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: spacing.md,
		backgroundColor: colors.background.light,
		borderRadius,
		padding: spacing.lg,
		width: '100%',
	},

	divider: {
		width: '100%',
		height: 1,
		backgroundColor: colors.border.light,
	},

	iconWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '48px',
		height: '48px',
		borderRadius: '50%',
		backgroundColor: colors.primary.main,
		margin: '0',
	},

	icon: {
		color: colors.background.light,
		width: '24px',
		height: '24px',
	},

	content: {
		display: 'flex',
		width: '100%',
		backgroundColor: 'rgba(0, 204, 255, 0.05)',
		borderRadius,
		[queries.lg]: {
			flexDirection: 'column-reverse',
		},
	},
	header: {
		color: colors.text.dark,
	},

	cardColumn: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'visible',
	},
	leftColumn: {
		padding: spacing.md,
		gap: spacing.md,
	},

	cardHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	},

	headerContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		fontSize: typography.fontSizes.lg,
		color: colors.primary.main,
		gap: spacing.sm,
		flex: 1,
	},

	description: {
		fontSize: typography.fontSizes.lg,
		color: colors.primary.main,
		margin: '0',
		maxHeight: '70px',
		minWidth: '170px',
	},

	button: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: colors.primary.main,
		color: colors.background.light,
		border: 'none',
		borderRadius: '6px',
		padding: '12px 20px',
		fontSize: '14px',
		cursor: 'pointer',
		transition: 'all 0.2s ease-in-out',
		marginTop: '8px',
		':hover': {
			backgroundColor: '#2563eb',
			transform: 'translateY(-1px)',
		},
		':active': {
			transform: 'translateY(0)',
		},
		':focus': {
			outline: 'none',
			boxShadow: `0 0 0 3px ${colors.primary.main}33`,
		},
	},
	graphic: {
		marginTop: '-10px',
	},
});
